export class ModulesCommon {
  static fullscreenIframeDivId = "fullscreen_iframe";
}

export class BaseModules {}
